import { PublicConfig } from 'server-schemas/configs';
let config: PublicConfig;

export const set = (t: PublicConfig) => {
  config = { ...t, ...config };
};

export const get = () => {
  return config;
};
